import { getApolloClient } from '#providers/apollo/initializeClient';
import {
  CreateFavoriteItemDocument,
  DeleteFavoriteItemDocument,
  GetFavoritesForProfileDocument,
} from '#types/generated/apollo-client';
import { FavoriteItem } from '#types/generated/graphql-types';

export const api = {
  async getFavourites(profileId: number): Promise<FavoriteItem[]> {
    const client = getApolloClient();
    const { data } = await client.query({
      query: GetFavoritesForProfileDocument,
      variables: {
        profileId,
      },
      fetchPolicy: 'network-only',
    });

    return data.favorites.map((item) => ({ ...item }));
  },
  async addFavourite(profileId: number, iri: string): Promise<FavoriteItem> {
    const client = getApolloClient();
    const { data } = await client.mutate({
      mutation: CreateFavoriteItemDocument,
      variables: {
        profileId,
        iri,
      },
    });

    if (data.createFavorite) {
      return data.createFavorite;
    } else {
      return null;
    }
  },
  removeFavourite(profileId: number, id: number) {
    const client = getApolloClient();
    client.mutate({
      mutation: DeleteFavoriteItemDocument,
      variables: {
        profileId,
        id,
      },
    });
  },
};
